module.exports = __webpack_public_path__ + "images/wechat/arrow-1190e96d89353c6ccc3f3526e9822c40.png";